export default {
  components: {
  },
  props: ['type'],
  data() {
    return {
    };
  },
  created() {
    // console.log(this.type, '瑕疵声明及重大事项提示');
  },
  computed: {
  },
  methods: {
  }
};
